import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 48667BD8-2891-45D0-92E9-F4FF292527A4
 * name phone-rotate-landscape
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-rotate-landscape.svg
 * tags
 * - Cellphone / Phone 
 */
export const PhoneRotateLandscapeIcon = createSvgIcon(<><path d="M9,1H3A2,2 0 0,0 1,3V16A2,2 0 0,0 3,18H9A2,2 0 0,0 11,16V3A2,2 0 0,0 9,1M9,15H3V3H9V15M21,13H13V15H21V21H9V20H6V21A2,2 0 0,0 8,23H21A2,2 0 0,0 23,21V15A2,2 0 0,0 21,13M23,10L19,8L20.91,7.09C19.74,4.31 17,2.5 14,2.5V1A9,9 0 0,1 23,10Z" /></>, 'PhoneRotateLandscapeIcon');
export default PhoneRotateLandscapeIcon